module.exports = __webpack_public_path__ + "img/lens-160-minus-02.f133ef19.png";